import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { AssetTypesViewTopBar } from "./TopBar"

export const assetTypesViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: AssetTypesViewTopBar,
}
